<template>
  <container-slot>
    <v-col cols="12" md="4" v-show="breakpoints.mdAndUp"> </v-col>
    <v-col cols="12" md="4">
      <v-text-field
        append-icon="mdi-magnify"
        class="mt-5"
        color="#6fbee2"
        label="Search News"
        solo
        v-model="keyword"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="4" v-show="breakpoints.mdAndUp"> </v-col>

    <v-col cols="12" md="1" v-if="removeClicked && breakpoints.mdAndUp">
    </v-col>
    <v-col cols="12" md="10" v-if="removeClicked">
      <v-alert
        :type="!error ? `success` : `error`"
        ref="alert"
        dismissible
        @input="defaultAlert"
        class="noMarg"
        v-show="removeClicked"
      >
        {{ msg }}
      </v-alert>
    </v-col>
    <v-col cols="12" md="1" v-if="removeClicked && breakpoints.mdAndUp">
    </v-col>

    <v-col cols="12">
      <v-card color="#6fbee2" dark elevation="5">
        <v-card-text>
          <v-data-table
            class="elevation-1 my-auto"
            light
            loading-text="Retrieving data... Please wait"
            :headers="headerNews"
            :items="filterNews"
            :items-per-page="5"
            :loading="$apollo.loading"
            :search="keyword"
          >
            <template v-slot:item.createdAt="{ item }">
              {{ fDate(item.createdAt) }}
            </template>
            <template v-slot:item.updatedAt="{ item }">
              {{ fDate(item.updatedAt) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <td>
                <v-btn
                  color="blue-grey"
                  class="white--text"
                  @click="$router.push(`/news/edit/${item.id}`)"
                  :disabled="!item.sameUser"
                >
                  Edit
                  <v-icon right dark>mdi-square-edit-outline</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn
                  color="error"
                  class="white--text"
                  @click="removeRow(item.id)"
                  :disabled="!item.sameUser"
                >
                  Remove
                  <v-icon right dark>mdi-trash-can</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </container-slot>
</template>

<script>
/* eslint-disable no-console */
import ContainerSlot from "@/components/ContainerSlot";
import { news } from "@/utils/graphqlQuery";
import { editNews } from "@/utils/graphqlMutation";
import { lsUtils } from "@/utils/localStorageUtils";
import moment from "moment";

const { id } = lsUtils.getItem("userToken").userData;

export default {
  apollo: {
    news: {
      query: news,
      update: ({ news }) => {
        news.sort(function (a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        return news.map((eachNews, i) => ({
          ...eachNews,
          no: i + 1,
          title:
            eachNews.title.length > 15
              ? `${eachNews.title.substring(0, 15)}...`
              : eachNews.title,
          searchTitle: eachNews.title,
          author: eachNews.author
            ? eachNews.author.userName
            : "Not Active Account",
          sameUser: eachNews.author ? eachNews.author.id == id : false,
        }));
      },
    },
  },
  components: {
    ContainerSlot,
  },
  computed: {
    breakpoints() {
      return {
        mdAndUp: this.$vuetify.breakpoint.mdAndUp,
        smAndDown: this.$vuetify.breakpoint.smAndDown,
      };
    },
    filterNews() {
      return this.news.filter((item) =>
        item.searchTitle.toLowerCase().includes(this.keyword)
      );
    },
  },
  data() {
    return {
      error: false,
      keyword: "",
      msg: "",
      removeClicked: false,
      news: [],
      headerNews: [
        { text: "No", field: "no", value: "no" },
        { text: "Title", field: "title", value: "title" },
        { text: "Author", field: "author", value: "author" },
        { text: "Created At", field: "createdAt", value: "createdAt" },
        { text: "Updated At", field: "updatedAt", value: "updatedAt" },
        { text: "Actions", field: "actions", value: "actions" },
      ],
    };
  },
  name: "ListNews",
  methods: {
    defaultAlert() {
      this.removeClicked = false;
      this.error = false;
      this.msg = "";
    },
    fDate(dateStr) {
      return moment(new Date(dateStr)).format("DD/MM/YYYY HH:mm:ss");
    },
    async removeRow(id) {
      const that = this;
      this.defaultAlert();
      const permission = confirm("Are you sure want to remove this news ?");
      if (permission) {
        const newsObj = {
          id,
          isDeleted: 1,
        };
        const gqlNews = news;
        try {
          const { data } = await this.$apollo.mutate({
            mutation: editNews,
            variables: {
              newsObj,
            },
            update: (store) => {
              const { news } = store.readQuery({
                query: gqlNews,
              });
              const uNews = news.filter((item) => item.id != id);
              store.writeQuery({
                query: gqlNews,
                data: {
                  news: uNews,
                },
              });
              that.news = uNews;
            },
          });
          const { success, msg } = data.editNews;

          if (!success) {
            throw new Error(msg);
          }
          this.error = false;
          this.msg = msg;
        } catch (error) {
          this.error = true;
          this.msg = error.message;
        } finally {
          this.removeClicked = true;
        }
      }
    },
  },
  title() {
    return "List News";
  },
};
</script>
